import { IconButton, type IIconsButtonProps } from "@similarweb/ui-components";

import { CrmManagementDisabledTooltip } from "app/pages/sales-intelligence/common-components/CrmManagementDisabledTooltip";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

type Props = Pick<IIconsButtonProps, "isDisabled" | "onClick"> & Partial<Pick<IIconsButtonProps, "type">>;

const CreateJobButton = ({ type = "primary", isDisabled, onClick }: Props) => {
    const renderButton = (isReadOnly: boolean) => (
        <IconButton
            type={type}
            iconName="add"
            iconSize="sm"
            placement="left"
            isDisabled={isDisabled || isReadOnly}
            onClick={onClick}
            dataAutomation="crm-enrichment-create-job-button"
        >
            <I18n translatable={{ key: "si.crm-enrichment.job.create-new" }} />
        </IconButton>
    );

    return <CrmManagementDisabledTooltip renderContent={renderButton} />;
};

export default CreateJobButton;
